/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramProductsControllerFindOneQueryResponse,
  TelegramProductsControllerFindOnePathParams,
  TelegramProductsControllerFindOneQueryParams,
  TelegramProductsControllerFindOne401,
} from '../../types/TelegramProductsControllerFindOne.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramProductsFindOne } from '../../methods/telegramProductsFindOne.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramProductsFindOneQueryKey = (
  link: TelegramProductsControllerFindOnePathParams['link'],
  params?: TelegramProductsControllerFindOneQueryParams,
) => [{ url: '/api/telegram/products/:link', params: { link: link } }, ...(params ? [params] : [])] as const;

export type TelegramProductsFindOneQueryKey = ReturnType<typeof telegramProductsFindOneQueryKey>;

export function telegramProductsFindOneQueryOptions(
  link: TelegramProductsControllerFindOnePathParams['link'],
  params?: TelegramProductsControllerFindOneQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramProductsFindOneQueryKey(link, params);
  return queryOptions<
    TelegramProductsControllerFindOneQueryResponse,
    ResponseErrorConfig<TelegramProductsControllerFindOne401>,
    TelegramProductsControllerFindOneQueryResponse,
    typeof queryKey
  >({
    enabled: !!link,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramProductsFindOne(link, params, config);
    },
  });
}

/**
 * {@link /api/telegram/products/:link}
 */
export function useTelegramProductsFindOne<
  TData = TelegramProductsControllerFindOneQueryResponse,
  TQueryData = TelegramProductsControllerFindOneQueryResponse,
  TQueryKey extends QueryKey = TelegramProductsFindOneQueryKey,
>(
  link: TelegramProductsControllerFindOnePathParams['link'],
  params?: TelegramProductsControllerFindOneQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramProductsControllerFindOneQueryResponse,
        ResponseErrorConfig<TelegramProductsControllerFindOne401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramProductsFindOneQueryKey(link, params);

  const query = useQuery(
    {
      ...telegramProductsFindOneQueryOptions(link, params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<TelegramProductsControllerFindOne401>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
